export default {"src":"/_next/static/media/bybit.618616b8.svg","height":28,"width":28};